import { Box, Typography, Tooltip, Chip } from "@mui/material";
import { useAppVersion } from "src/hooks/useAppVersion";

interface AppVersionProps {
  variant?: "compact" | "detailed" | "navbar" | "badge";
  showLabel?: boolean;
}

const AppVersion: React.FC<AppVersionProps> = ({
  variant = "compact",
  showLabel = true,
}) => {
  const { version } = useAppVersion();

  if (variant === "navbar") {
    return (
      <Tooltip title={`App Version: ${version}`}>
        <Chip
          label={`V${version}`}
          size="small"
          variant="outlined"
          sx={{
            height: "24px",
            fontSize: "0.7rem",
            fontWeight: 600,
            borderColor: "#002D62",
            color: "#002D62",
            backgroundColor: "rgba(0, 45, 98, 0.05)",
            "&:hover": {
              backgroundColor: "rgba(0, 45, 98, 0.1)",
            },
            cursor: "default",
            userSelect: "none",
          }}
        />
      </Tooltip>
    );
  }

  // Badge variant - more prominent badge
  if (variant === "badge") {
    return (
      <Tooltip title={`Version: ${version}`}>
        <Chip
          label={`V${version}`}
          size="small"
          icon={<span style={{ fontSize: "12px" }}>ℹ️</span>}
          sx={{
            backgroundColor: "#002D62",
            color: "white",
            fontWeight: 600,
            cursor: "default",
            userSelect: "none",
          }}
        />
      </Tooltip>
    );
  }

  // Sidebar variant - footer style
  const versionText = variant === "compact" ? `V${version}` : `App V${version}`;

  return (
    <Tooltip title={`Version: ${version}`}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 1,
          px: 2,
          borderTop: "1px solid",
          borderColor: "divider",
          backgroundColor: "background.paper",
        }}
      >
        <Typography
          variant="caption"
          sx={{
            color: "text.secondary",
            fontWeight: 500,
            userSelect: "none",
            cursor: "default",
          }}
        >
          {showLabel ? versionText : version}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default AppVersion;
